import { FAIRE_RETAILERS_NUMBER_OF_CITIES } from "@faire/web-api/indigofair/settings/FAIRE_RETAILERS_NUMBER_OF_CITIES";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingTotalRetailerCitiesCount = (): number =>
  getSettingValueWithoutAssignment(FAIRE_RETAILERS_NUMBER_OF_CITIES, 50000);
